export { default as TableSortDisplay } from './component';
